
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { loginOrganization } from "../Actions/Organization/AuthActions";
import { AppDispatch } from "../store";
import { Link, redirect, useNavigate } from "react-router-dom";
import LoadingButton from "../Components/LoadingButton";
import Error from "../Components/Error";
import logo from "../Images/logo.png"
import axios, { isAxiosError } from "axios";
import { useTranslation } from "react-i18next";

 const ForgotPassword:React.FC = ()=>{
    const [email,setEmail] = useState('')
    const [error,setErrror] = useState('')
    const [loading, setLoading] = useState(false)
    const [message,setMessage] = useState("")
    const [sent,setSent] = useState(false)
    const {t} = useTranslation()

      // Send verification code
    const triggerReset = async () => {
        setLoading(true)
        try {
       
          var response = await axios.post(`${process.env.REACT_APP_HOST}Organization/reset-password/${email}`);
       
          // Same wording whether or not the email has an account (the API doesn't reveal it either)
          setMessage(t("resetLinkSentIfExists"));
          setSent(true)
          setLoading(false)
        } catch (error) {
          if(isAxiosError(error)){
            const errorMessage = error.response?.data.message || "Failed to Reset Link . Please try again.";
            console.log(error)
            setErrror(errorMessage);
            setLoading(false)
          }
        }
    };

    return (
    <>
    <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <img className="mx-auto w-20 " src={logo} alt="Vit"/>
        <h2 className="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900"> {t("resetPassword")}</h2>
      </div>
      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form className="space-y-6" action="#" method="POST">
          {!sent?<div>
            <label htmlFor="email"  className="block text-sm/6 font-medium text-gray-900">{t("email")}</label>
            <div className="mt-2">
              <input type="email" onChange={(emai)=>{setEmail(emai.target.value)}} name="email" id="email" autoComplete="email" required className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-brand-600 sm:text-sm/6"></input>
            </div>
          </div>:""}
            <p>{message}</p>
          {error?
            <Error message={error} />: "" }
          <div>
          {loading? <LoadingButton/>:!sent?<button type="button" onClick={()=>{triggerReset()}} className="flex w-full justify-center rounded-md bg-brand-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-brand-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600">{t("send")}</button>
          :""
             }</div>
        </form>
      </div>
    </div>
      </>)
}

export default ForgotPassword;